import script from "./VideoPlayer.vue?vue&type=script&lang=ts&setup=true"
export * from "./VideoPlayer.vue?vue&type=script&lang=ts&setup=true"

import "./VideoPlayer.vue?vue&type=style&index=0&id=77229a05&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77229a05"]])

export default __exports__